import { set, lensProp, mergeRight, replace } from "ramda";
import valueToContentAdapter from "./valueToContentAdapter";
import getCountry from "module/functions/getCountry";
import { TITLE } from "application/constants/app-constants";

export function adaptFormToBack(value, structure, locale, id, hasPaypalValue = false) {
  const country = getCountry();
  const form = {
    id: id,
    defaultLanguage: replace("-", "_", locale),
    structureId: structure.id,
    status: hasPaypalValue ? "PUBLISHED" : "DRAFT",
    publishDate: new Date(),
    categoriesId: [],
    tagsId: [],
    version: {
      language: replace("-", "_", locale),
      title: TITLE + country.toUpperCase(),
      contentFields: value,
    },
  };
  delete form.version.contentFields.province_fake;
  return prepareContentForSubmit(form, structure);
}

const prepareContentForSubmit = (value, structure) => {
  const contentObject = valueToContentAdapter(value.version.contentFields, structure.structureFields);
  const valueWithContentWithoutNames = set(
    lensProp("version"),
    mergeRight(value.version, { contentFields: contentObject }),
    value
  );

  return valueWithContentWithoutNames;
};
